export default "__VITE_ASSET__C5E7lvKB__"